import { hasVerifiedBillingInvoiceIdentity } from "@shared/billing/billing-due-date";

export const INVOICE_PAID_PENDING_ECONOMIC_REVIEW_LABEL =
  "Factura cobrada; hito pendiente de revisión económica";
export const INVOICE_REVIEW_REQUIRED_LABEL = "Revisión de factura; sin deuda cobrable verificada";

function amountCents(value: unknown): number | null {
  if (typeof value !== "number" && typeof value !== "string") return null;
  const normalized = String(value).trim();
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
  const amount = Number(normalized);
  return Number.isFinite(amount) ? Math.round(amount * 100) : null;
}

export function isInvoicePaidPendingEconomicReview(input: {
  balanceAmount?: unknown;
  invoiceEconomicReviewRequired?: unknown;
  invoiceNumber?: unknown;
  invoiceDate?: unknown;
  invoiceFiscalVerified?: unknown;
}): boolean {
  if (input.invoiceEconomicReviewRequired !== true || input.balanceAmount == null || !hasVerifiedBillingInvoiceIdentity(input)) return false;
  return amountCents(input.balanceAmount) === 0;
}

type CollectionPresentationState = {
  status?: unknown;
  collectionStatus?: unknown;
  balanceAmount?: unknown;
  invoiceNumber?: unknown;
  invoiceDate?: unknown;
  invoiceFiscalVerified?: unknown;
};

function hasInvalidPresentBalance(input: CollectionPresentationState): boolean {
  return input.balanceAmount != null && amountCents(input.balanceAmount) === null;
}

export function isInvoiceCollectionComplete(input: CollectionPresentationState): boolean {
  if (input.status === "collected") return true;
  if (!hasVerifiedBillingInvoiceIdentity(input)) return false;
  if (input.balanceAmount != null) {
    const balanceCents = amountCents(input.balanceAmount);
    return balanceCents === 0;
  }
  return input.collectionStatus === "collected";
}

export function isInvoiceCollectionPending(input: CollectionPresentationState): boolean {
  if (input.status === "collected") return false;
  if (!hasVerifiedBillingInvoiceIdentity(input)) return false;
  if (input.balanceAmount != null) {
    const balanceCents = amountCents(input.balanceAmount);
    return balanceCents !== null && balanceCents > 0;
  }
  return input.collectionStatus === "pending_collection";
}

export function billingMilestoneDisplayStatus(input: CollectionPresentationState): string {
  const invoiceStatuses = new Set(["invoiced", "sent_to_client", "pending_collection", "collected"]);
  if (input.status === "collected") return "collected";
  if (typeof input.collectionStatus === "string" && input.collectionStatus === "invoice_review") return "invoice_review";
  if (hasInvalidPresentBalance(input)) return "invoice_review";
  if (invoiceStatuses.has(String(input.status ?? "")) && !hasVerifiedBillingInvoiceIdentity(input)) return "invoice_review";
  if (isInvoiceCollectionPending(input)) return "pending_collection";
  if (isInvoiceCollectionComplete(input)) return "collected";
  return typeof input.status === "string" ? input.status : "";
}
